(function (root) {
  'use strict';

  function normalizeQuantity(value) {
    var quantity = Number.parseInt(value, 10);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 0;
  }

  function calculateCombinedTotal(mainItem, accessoryItems) {
    var mainTotal = Number(mainItem.price || 0) * normalizeQuantity(mainItem.quantity);
    return accessoryItems.reduce(function (total, item) {
      return total + Number(item.price || 0) * normalizeQuantity(item.quantity);
    }, mainTotal);
  }

  function buildCartItems(mainItem, accessoryItems) {
    var items = [];
    var main = {
      id: Number(mainItem.id),
      quantity: normalizeQuantity(mainItem.quantity),
    };

    if (mainItem.properties && Object.keys(mainItem.properties).length > 0) {
      main.properties = mainItem.properties;
    }

    items.push(main);

    accessoryItems.forEach(function (item) {
      var quantity = normalizeQuantity(item.quantity);
      if (quantity > 0) {
        items.push({ id: Number(item.id), quantity: quantity });
      }
    });

    return items;
  }

  function quantitiesByVariant(lines) {
    return lines.reduce(function (totals, line) {
      var id = Number(line.variant_id || line.id);
      totals[id] = (totals[id] || 0) + normalizeQuantity(line.quantity);
      return totals;
    }, {});
  }

  function compareCartSnapshots(beforeLines, afterLines, requestedItems) {
    var before = quantitiesByVariant(beforeLines);
    var after = quantitiesByVariant(afterLines);

    return requestedItems.map(function (item) {
      return {
        id: Number(item.id),
        title: item.title,
        requested: normalizeQuantity(item.quantity),
        added: Math.max(0, (after[Number(item.id)] || 0) - (before[Number(item.id)] || 0)),
      };
    });
  }

  function formatMoney(cents, format) {
    var amount = Number(cents || 0) / 100;
    return format
      .replace('{{amount_no_decimals}}', Math.round(amount).toLocaleString('en-US'))
      .replace('{{amount}}', amount.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }));
  }

  async function submitSelection(options) {
    var accessoryItems = options.accessoryItems || [];
    var selectedAccessories = accessoryItems.filter(function (item) {
      return normalizeQuantity(item.quantity) > 0;
    });

    if (selectedAccessories.length === 0) {
      return options.addSingle(options.mainItem);
    }

    var beforeCart;

    try {
      beforeCart = await options.getCart();
    } catch (error) {
      if (options.onError) {
        options.onError(error, [], null, {
          requestAttempted: false,
          verified: false,
        });
      }
      throw error;
    }

    var cartItems = buildCartItems(options.mainItem, selectedAccessories);

    try {
      var result = await options.addBundle(cartItems);
      if (options.onSuccess) {
        options.onSuccess(result);
      }
      return result;
    } catch (error) {
      var afterCart;

      try {
        afterCart = await options.getCart();
      } catch (recoveryError) {
        if (options.onError) {
          options.onError(error, [], null, {
            requestAttempted: true,
            verified: false,
            recoveryError: recoveryError,
          });
        }
        throw error;
      }

      var requestedItems = [options.mainItem].concat(selectedAccessories);
      var outcome = compareCartSnapshots(beforeCart.items || [], afterCart.items || [], requestedItems);
      if (options.onError) {
        options.onError(error, outcome, afterCart, {
          requestAttempted: true,
          verified: true,
        });
      }
      throw error;
    }
  }

  function parseJson(element, fallback) {
    if (!element) return fallback;
    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      return fallback;
    }
  }

  function selectedMainVariant(form, variants) {
    var idField = form.querySelector('[name="id"]');
    var id = idField ? Number(idField.value) : 0;
    return variants.find(function (variant) {
      return Number(variant.id) === id;
    }) || null;
  }

  function mainQuantity(form) {
    var field = form.querySelector('[name="quantity"]');
    return Math.max(1, normalizeQuantity(field ? field.value : 1));
  }

  function lineProperties(form) {
    var properties = {};
    form.querySelectorAll('[name^="properties["]').forEach(function (field) {
      if (field.disabled || ((field.type === 'checkbox' || field.type === 'radio') && !field.checked)) return;
      var match = field.name.match(/^properties\[(.+)\]$/);
      if (match && field.value !== '') properties[match[1]] = field.value;
    });
    return properties;
  }

  function accessoryItems(section) {
    return Array.prototype.map.call(section.querySelectorAll('[data-vp-product-row]'), function (row) {
      var quantityField = row.querySelector('[data-vp-quantity]');
      return {
        id: Number(row.dataset.vpVariantId),
        price: Number(row.dataset.vpVariantPrice),
        quantity: normalizeQuantity(quantityField ? quantityField.value : 0),
        title: row.dataset.vpProductTitle,
      };
    });
  }

  function hasSelectedAccessories(section) {
    return accessoryItems(section).some(function (item) { return item.quantity > 0; });
  }

  function money(cents, format) {
    if (root.theme && root.theme.Currency && typeof root.theme.Currency.formatMoney === 'function') {
      return root.theme.Currency.formatMoney(cents, format);
    }
    return formatMoney(cents, format);
  }

  function setButtonsBusy(buttons, busy) {
    buttons.forEach(function (button) {
      if (busy) {
        button.dataset.vpWasDisabled = button.disabled ? 'true' : 'false';
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      } else {
        var wasDisabled = button.dataset.vpWasDisabled === 'true';
        button.disabled = wasDisabled;
        if (!wasDisabled) button.removeAttribute('aria-disabled');
        delete button.dataset.vpWasDisabled;
      }
    });
  }

  function refreshThemeCart(result) {
    var ajaxCart = root.theme && root.theme.AjaxCart;
    var eventName = ajaxCart && ajaxCart.eventStrs && ajaxCart.eventStrs.addToCartSuccess;

    if (root.jQuery && eventName) root.jQuery('body').trigger(eventName);

    document.dispatchEvent(new CustomEvent('vp:cart:add:success', { detail: result }));
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: result }));
  }

  function refreshThemeCartCount(cart) {
    var ajaxCart = root.theme && root.theme.AjaxCart;
    var eventName = ajaxCart && ajaxCart.eventStrs && ajaxCart.eventStrs.getCartSuccess;
    if (root.jQuery && eventName) root.jQuery('body').trigger(eventName, [cart]);
  }

  function requestJson(url, options) {
    return root.fetch(url, options).then(async function (response) {
      var payload = await response.json().catch(function () { return {}; });
      if (!response.ok) {
        var error = new Error(payload.description || payload.message || 'Cart request failed');
        error.payload = payload;
        throw error;
      }
      return payload;
    });
  }

  function initSection(section) {
    if (section.dataset.vpInitialized === 'true') return;
    section.dataset.vpInitialized = 'true';

    var form = section.closest('form');
    if (!form) return;

    var variants = parseJson(section.querySelector('[data-vp-main-variants]'), []);
    var buttons = Array.prototype.slice.call(form.querySelectorAll('.js-vp-accessories-cart-btn'));
    var totalWrap = section.querySelector('[data-vp-total-wrap]');
    var totalValue = section.querySelector('[data-vp-total]');
    var status = section.querySelector('[data-vp-status]');
    var paymentButtons = Array.prototype.slice.call(form.querySelectorAll('.shopify-payment-button'));
    var moneyFormat = section.dataset.moneyFormat || '{{amount}}';

    function currentMainItem() {
      var variant = selectedMainVariant(form, variants);
      return variant ? {
        id: variant.id,
        price: variant.price,
        quantity: mainQuantity(form),
        properties: lineProperties(form),
        title: variant.name || variant.title,
      } : null;
    }

    function updateSummary() {
      var selected = hasSelectedAccessories(section);
      var main = currentMainItem();
      var items = accessoryItems(section);

      if (selected && main) {
        totalValue.textContent = money(calculateCombinedTotal(main, items), moneyFormat);
        totalWrap.hidden = false;
      } else {
        totalWrap.hidden = true;
      }

      paymentButtons.forEach(function (paymentButton) { paymentButton.hidden = selected; });
    }

    section.querySelectorAll('[data-vp-product-row]').forEach(function (row) {
      var input = row.querySelector('[data-vp-quantity]');
      var minus = row.querySelector('[data-vp-quantity-minus]');
      var plus = row.querySelector('[data-vp-quantity-plus]');
      var select = row.querySelector('[data-vp-variant-select]');
      var controls = row.querySelector('[data-vp-quantity-controls]');
      var soldOut = row.querySelector('[data-vp-sold-out]');
      var price = row.querySelector('[data-vp-price]');
      var image = row.querySelector('.vp-accessories__image');

      function setQuantity(next) {
        input.value = Math.max(0, Math.min(99, normalizeQuantity(next)));
        minus.disabled = Number(input.value) === 0;
        updateSummary();
      }

      if (minus) minus.addEventListener('click', function () { setQuantity(Number(input.value) - 1); });
      if (plus) plus.addEventListener('click', function () { setQuantity(Number(input.value) + 1); });

      if (select) select.addEventListener('change', function () {
        var option = select.options[select.selectedIndex];
        var available = option.dataset.available === 'true';
        row.dataset.vpVariantId = option.value;
        row.dataset.vpVariantPrice = option.dataset.price;
        row.dataset.vpAvailable = String(available);
        price.textContent = money(Number(option.dataset.price), moneyFormat);
        soldOut.hidden = available;
        controls.hidden = !available;
        if (!available) setQuantity(0);
        if (image && option.dataset.image) image.src = option.dataset.image;
        updateSummary();
      });
    });

    form.addEventListener('change', function (event) {
      if (event.target.matches('[name="id"], [name="quantity"]')) updateSummary();
    });
    form.addEventListener('click', function (event) {
      if (event.target.closest('[class*="qty"], [class*="quantity"]')) root.setTimeout(updateSummary, 0);
    });

    var bundleRequestRunning = false;
    var bundleRetryBlocked = false;

    function handleBundleSubmit(event) {
      if (bundleRetryBlocked) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!status.textContent) status.textContent = section.dataset.cartReviewRequired;
        return;
      }

      if (!hasSelectedAccessories(section)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      if (bundleRequestRunning) return;

      var main = currentMainItem();
      if (!main || !main.id) {
        status.textContent = section.dataset.cartError;
        return;
      }

      var accessories = accessoryItems(section);
      bundleRequestRunning = true;
      setButtonsBusy(buttons, true);
      status.textContent = '';

      submitSelection({
        mainItem: main,
        accessoryItems: accessories,
        getCart: function () {
          return requestJson(section.dataset.cartUrl, { credentials: 'same-origin' });
        },
        addBundle: function (items) {
          return requestJson(section.dataset.cartAddUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items }),
          });
        },
        onSuccess: function (result) {
          section.querySelectorAll('[data-vp-quantity]').forEach(function (input) { input.value = 0; });
          section.querySelectorAll('[data-vp-quantity-minus]').forEach(function (minus) { minus.disabled = true; });
          refreshThemeCart(result);
          updateSummary();
        },
        onError: function (error, outcome, cart, context) {
          if (!context || context.requestAttempted === false) {
            status.textContent = section.dataset.cartReadError;
            return;
          }

          if (!context.verified) {
            bundleRetryBlocked = true;
            status.textContent = section.dataset.cartReviewRequired;
            return;
          }

          var details = outcome.map(function (item) {
            return section.dataset.stockTemplate
              .replace('__PRODUCT__', item.title || String(item.id))
              .replace('__ADDED__', String(item.added))
              .replace('__REQUESTED__', String(item.requested));
          });
          var anythingAdded = outcome.some(function (item) { return item.added > 0; });
          if (anythingAdded) bundleRetryBlocked = true;
          status.textContent = [
            anythingAdded ? section.dataset.cartReviewRequired : section.dataset.cartError,
          ].concat(details).join(' ');
          refreshThemeCartCount(cart);
        },
      }).catch(function () {}).finally(function () {
        bundleRequestRunning = false;
        setButtonsBusy(buttons, false);
        if (bundleRetryBlocked) {
          buttons.forEach(function (button) {
            button.disabled = true;
            button.setAttribute('aria-disabled', 'true');
          });
        }
      });
    }

    buttons.forEach(function (button) {
      button.addEventListener('click', handleBundleSubmit, true);
    });
    form.addEventListener('submit', handleBundleSubmit, true);

    updateSummary();
  }

  function init(scope) {
    var container = scope || document;
    container.querySelectorAll('[data-vp-accessories]').forEach(initSection);
  }

  root.VPCompatibleAccessories = {
    buildCartItems: buildCartItems,
    calculateCombinedTotal: calculateCombinedTotal,
    compareCartSnapshots: compareCartSnapshots,
    formatMoney: formatMoney,
    init: init,
    submitSelection: submitSelection,
  };

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }
  }
})(typeof window === 'undefined' ? globalThis : window);
